import { render, staticRenderFns } from "./academic_schdual_refereesystem_half.vue?vue&type=template&id=31e90329&scoped=true&"
import script from "./academic_schdual_refereesystem_half.vue?vue&type=script&lang=js&"
export * from "./academic_schdual_refereesystem_half.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e90329",
  null
  
)

export default component.exports